// Menu rules shared by the sidebar, the phone bars and the applications centre (lib/apps.js). Which entries a person sees is
// decided by Layout.jsx (permissions, module switches), never here.

export const UPCOMING_LABEL = "Pas encore disponible";

// An entry may cover sibling pages (`also`: e.g. « Offres et abonnements » opens the subscriptions and the offers lists).
// `except`: sub-pages that have their own entry (the register's « Obligations » under /documents), so only that entry lights up.
export function matchesPath(item, pathname) {
  const under = (to) => !!to && (pathname === to || pathname.startsWith(`${to}/`));
  if ((item.except || []).some(under)) return false;
  return [item.to, ...(item.also || [])].some(under);
}
